import { API } from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-records-ext/call-quality/v1/api.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaV1Service = bindHTTP(API);
export const serviceName = 'v1' as const;
